<template>
  <div>
    <v-menu bottom right :close-on-content-click="false" v-model="menu">
      <template v-slot:activator="{ on }">
        <v-btn fab icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-action> <v-icon>mdi-cogs</v-icon> </v-list-item-action
            >Visible Columns{{ hideSearch ? "" : " & Filter" }}
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-container>
              <v-select
                label="Visible Columns"
                :items="selectableHeaders"
                v-model="selectedColumns"
                multiple
                hint="Show/Hide Columns"
                persistent-hint
                item-value="name"
                chips
                deletable-chips
                @change="onVisibleColumnsChange"
                :outlined="outlinedInputs"
              ></v-select>
            </v-container>
          </v-list-item>
          <v-list-item v-if="!hideSearch">
            <v-container>
              <v-text-field
                append-icon="mdi-magnify"
                label="Quick Filter..."
                single-line
                hide-details
                v-model="search"
                @input="onSearchChange"
                clearable
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-container>
          </v-list-item>
        </v-list>
        <v-list-item>
          <v-container>
            <slot></slot>
          </v-container>
        </v-list-item>
        <v-list-item v-if="debug">
          <v-container>
            <pre>
              {{ selectedColumns }}
            </pre>
          </v-container>
        </v-list-item>
        <v-card-actions class="grey lighten-4">
          <custom-column-sets
            v-if="refName"
            :ref-name="refName"
            :current-columns="selectedColumns"
            @load-columns="onLoadColumns"
          />
          <v-spacer></v-spacer>
          <v-btn text @click="menu = false" color="warning">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <v-expansion-panels class="my-2" v-if="false">
      <v-expansion-panel>
        <v-expansion-panel-header
          >Visible Columns{{
            hideSearch ? "" : " &amp; Filter"
          }}</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <v-layout row wrap align-baseline>
            <v-flex xs12 sm8 class="pa-2">
              <v-select
                label="Visible Columns"
                :items="selectableHeaders"
                v-model="selectedColumns"
                multiple
                hint="Show/Hide Columns"
                persistent-hint
                item-value="name"
                chips
                deletable-chips
                @change="onVisibleColumnsChange"
                :outlined="outlinedInputs"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm4 class="pa-2"> </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <slot></slot>
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import CustomColumnSets from "./CustomColumnSets.vue";

export default {
  name: "ListVisibleColumnsAndFilter",
  components: {
    CustomColumnSets,
  },
  props: {
    hideSearch: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    visibleColumns: {
      type: Array,
      default: () => [],
    },
    selectableHeaders: {
      type: Array,
      default: () => [],
    },
    refName: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      debug: false,
      menu: false,
      search: this.value ? this.value : "",
      selectedColumns:
        this.visibleColumns.length > 0 ? [...this.visibleColumns] : [],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onVisibleColumnsChange(event) {
      this.$emit("change", event);
    },
    onSearchChange(event) {
      this.$emit("input", event);
    },
    onLoadColumns(event) {
      this.selectedColumns = [...event];
      this.$emit("change", this.selectedColumns);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ListVisibleColumnsAndFilter.vue